<div id="layout" class="sign_in f_col">
  <app-view-title class="mb_30" fromRoute="pre-enroll" [chooseLangBtn]="false">{{'user.new' | translate}}</app-view-title>
  <div class="scroll_wrapper resp_wrapper">
    <div class="resp_c-50 resp_scroll-wrapper_l">
      <app-view-deco-image class="mb_20" imageUrl="assets-projects/images/image_done.svg"></app-view-deco-image>
      <span class="text_center mb_30">{{'user.created' | translate}}</span>
      <app-slide-element leftIcon="location-dot" (btnClicked)="nav.to('user/' + userId)">{{'user.sheet.open' | translate}}</app-slide-element>
      <app-button size="sm" color="transparent" border="true" formId="form" class="fullWidth resp_minSize_l mt_10" (btnClicked)="nav.to('users')">{{'global.close' | translate}}</app-button>
    </div>
  </div>
  <div class="f_align_end f_grow mb_20 resp_maxSize_l">
    <app-back-btn icon="house" [navTo]="{route: 'dashboard'}"></app-back-btn>
    <div class="ml_10 fullWidth">
      <app-button color="transparent" border="true" formId="form" class="fullWidth" (btnClicked)="nav.to('users')">{{'global.close' | translate}}</app-button>
    </div>
  </div>
</div>
